import { z } from "zod";
import { ImageMediaSchema } from "../Media";
import { CharacterRoleSchema } from "../CharacterRole";
import { RichTextSchema } from "../RichText";
export const CharacterSchema = z.object({
    media: ImageMediaSchema.optional(),
    name: z.string(),
    role: CharacterRoleSchema.optional(),
});
export const CharacterChangeSchema = z.object({
    title: z.string().optional(),
    icon: ImageMediaSchema.optional(),
    description: RichTextSchema,
});
export const CharacterChangesSchema = z.object({
    character: CharacterSchema.optional(),
    summary: RichTextSchema.optional(),
    changes: z.array(CharacterChangeSchema),
});
//# sourceMappingURL=index.js.map